const NoRouteIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="141"
      height="140"
      viewBox="0 0 141 140"
      fill="none"
    >
      <g clipPath="url(#clip0_554_72089)">
        <path
          d="M100.825 112.297L90.5184 94.4462C85.9378 86.5124 91.6636 76.5953 100.825 76.5953C109.986 76.5953 115.711 86.5124 111.131 94.4462L100.825 112.297Z"
          fill="white"
        />
        <path
          d="M52.2435 137.266L41.9374 119.415C37.3567 111.481 43.0825 101.564 52.2435 101.564C61.4045 101.564 67.1303 111.481 62.5496 119.415L52.2435 137.266Z"
          fill="#C2C2F0"
        />
        <path
          d="M30.223 63.1427L19.9169 45.2919C15.3362 37.3581 21.062 27.441 30.223 27.441C39.384 27.441 45.1097 37.3581 40.5291 45.2919L30.223 63.1427Z"
          fill="white"
        />
        <path
          d="M125.459 38.436L115.153 20.5852C110.573 12.6514 116.298 2.73438 125.459 2.73438C134.62 2.73438 140.346 12.6514 135.766 20.5852L125.459 38.436Z"
          fill="#C2C2F0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.6455 38.4358C39.6455 36.9256 40.8697 35.7014 42.3799 35.7014H125.458C126.968 35.7014 128.192 36.9256 128.192 38.4358C128.192 39.9459 126.968 41.1702 125.458 41.1702H42.3799C40.8697 41.1702 39.6455 39.9459 39.6455 38.4358Z"
          fill="#29293D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9748 90.585C13.3186 90.585 10.9179 91.659 9.1733 93.4036C7.42985 95.147 6.35742 97.5474 6.35742 100.205C6.35742 105.518 10.6632 109.825 15.9748 109.825H40.0862C41.5964 109.825 42.8206 111.049 42.8206 112.559C42.8206 114.07 41.5964 115.294 40.0862 115.294H15.9748C7.64128 115.294 0.888672 108.537 0.888672 100.205C0.888672 96.0404 2.57796 92.2649 5.30631 89.5366C8.03355 86.8093 11.8086 85.1162 15.9748 85.1162H88.6654C90.1756 85.1162 91.3998 86.3404 91.3998 87.8506C91.3998 89.3607 90.1756 90.585 88.6654 90.585H15.9748Z"
          fill="#29293D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M61.6658 112.559C61.6658 111.049 62.89 109.825 64.4002 109.825H120.385C124.551 109.825 128.326 111.518 131.053 114.242L131.055 114.244C133.779 116.971 135.472 120.745 135.472 124.911C135.472 133.243 128.719 140 120.385 140H52.2432C50.733 140 49.5088 138.776 49.5088 137.266C49.5088 135.755 50.733 134.531 52.2432 134.531H120.385C125.697 134.531 130.003 130.224 130.003 124.911C130.003 122.256 128.93 119.856 127.188 118.111C125.443 116.368 123.042 115.294 120.385 115.294H64.4002C62.89 115.294 61.6658 114.07 61.6658 112.559Z"
          fill="#29293D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.7734 63.1447C78.7734 61.6345 79.9977 60.4103 81.5078 60.4103H120.386C124.551 60.4103 128.326 62.0996 131.054 64.8279L131.056 64.8291C133.779 67.5559 135.472 71.3304 135.472 75.4964C135.472 83.8283 128.719 90.5852 120.386 90.5852H112.983C111.473 90.5852 110.248 89.361 110.248 87.8508C110.248 86.3407 111.473 85.1164 112.983 85.1164H120.386C125.698 85.1164 130.003 80.8095 130.003 75.4964C130.003 72.8407 128.93 70.4398 127.187 68.6949C125.444 66.9515 123.044 65.879 120.386 65.879H81.5078C79.9977 65.879 78.7734 64.6548 78.7734 63.1447Z"
          fill="#29293D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.30631 40.1218C8.03354 37.3946 11.8086 35.7014 15.9748 35.7014H18.0655C19.5756 35.7014 20.7998 36.9256 20.7998 38.4358C20.7998 39.9459 19.5756 41.1702 18.0655 41.1702H15.9748C13.3186 41.1702 10.9179 42.2442 9.1733 43.9888C7.42985 45.7322 6.35742 48.1326 6.35742 50.7902C6.35742 56.1034 10.6632 60.4103 15.9748 60.4103H56.5417C58.0518 60.4103 59.2761 61.6345 59.2761 63.1447C59.2761 64.6549 58.0518 65.8791 56.5417 65.8791H15.9748C7.64128 65.8791 0.888672 59.1221 0.888672 50.7902C0.888672 46.6256 2.57796 42.8501 5.30631 40.1218Z"
          fill="#29293D"
        />
        <circle cx="125.459" cy="13.5256" r="2.73438" fill="#29293D" />
        <circle cx="30.2227" cy="38.4358" r="2.73438" fill="#29293D" />
        <circle cx="100.824" cy="87.8508" r="2.73438" fill="#29293D" />
        <circle cx="52.2432" cy="112.559" r="2.73438" fill="#29293D" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M100.824 79.3297C93.7677 79.3297 89.3575 86.9681 92.8856 93.079L92.8857 93.079L100.824 106.828L108.762 93.079L108.762 93.079C112.29 86.9681 107.88 79.3297 100.824 79.3297ZM88.1496 95.8133C82.5165 86.0566 89.5579 73.861 100.824 73.861C112.09 73.861 119.131 86.0566 113.498 95.8133C113.498 95.8134 113.498 95.8134 113.498 95.8134L103.192 113.664C102.703 114.51 101.801 115.031 100.824 115.031C99.8469 115.031 98.9442 114.51 98.4557 113.664L88.1496 95.8134C88.1496 95.8134 88.1496 95.8134 88.1496 95.8133Z"
          fill="#29293D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.2427 104.298C45.1866 104.298 40.7765 111.937 44.3046 118.048L44.3046 118.048L52.2427 131.797L60.1808 118.048L60.1808 118.048C63.7089 111.937 59.2988 104.298 52.2427 104.298ZM39.5685 120.782C33.9354 111.025 40.9768 98.8296 52.2427 98.8296C63.5086 98.8296 70.55 111.025 64.9169 120.782C64.9169 120.782 64.9169 120.782 64.9169 120.782L54.6107 138.633C54.1223 139.479 53.2196 140 52.2427 140C51.2658 140 50.3631 139.479 49.8747 138.633L39.5685 120.782C39.5685 120.782 39.5685 120.782 39.5685 120.782Z"
          fill="#29293D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.2222 30.1754C23.1661 30.1754 18.756 37.8138 22.2841 43.9247L22.2841 43.9247L30.2222 57.6739L38.1603 43.9247L38.1603 43.9247C41.6884 37.8138 37.2783 30.1754 30.2222 30.1754ZM17.548 46.659C11.9149 36.9023 18.9563 24.7067 30.2222 24.7067C41.488 24.7067 48.5295 36.9023 42.8964 46.659C42.8964 46.659 42.8964 46.6591 42.8964 46.6591L32.5902 64.5099C32.1018 65.3559 31.1991 65.8771 30.2222 65.8771C29.2453 65.8771 28.3426 65.3559 27.8541 64.5099L17.548 46.6591C17.548 46.6591 17.548 46.659 17.548 46.659Z"
          fill="#29293D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M117.52 19.218C117.52 19.218 117.52 19.218 117.52 19.2181L125.459 32.9673L133.397 19.218L133.397 19.218C136.925 13.1072 132.515 5.46875 125.459 5.46875C118.402 5.46875 113.992 13.1071 117.52 19.218ZM112.784 21.9523C107.151 12.1957 114.192 0 125.459 0C136.725 0 143.766 12.1956 138.133 21.9524C138.133 21.9524 138.133 21.9524 138.133 21.9524L127.827 39.8032C127.338 40.6492 126.436 41.1704 125.459 41.1704C124.482 41.1704 123.579 40.6492 123.091 39.8032L112.784 21.9524L112.784 21.9523Z"
          fill="#29293D"
        />
        <circle cx="69.002" cy="63.1427" r="2.73438" fill="#29293D" />
      </g>
      <defs>
        <clipPath id="clip0_554_72089">
          <rect width="140" height="140" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NoRouteIcon
